import Document from './Document'
import Query from './Query'
import Update from './Update'

export default
{
    Document,
    Query,
    Update,
}